<div class="layout-wrapper mt-4"  (click)="onLayoutClick()"
     [ngClass]="{'layout-static': app.menuMode === 'static',
                'layout-overlay': app.menuMode === 'overlay',
                'layout-slim': app.menuMode === 'slim',
                'layout-horizontal': app.menuMode === 'horizontal',
                'layout-sidebar': app.menuMode === 'sidebar',
                'layout-sidebar-static': app.menuMode === 'sidebar' && sidebarStatic,
                'layout-overlay-active': overlayMenuActive,
                'layout-mobile-active': staticMenuMobileActive,
                'layout-static-inactive': staticMenuDesktopInactive && app.menuMode === 'static',
                 'p-ripple-disabled': !app.ripple}">

    <div class="layout-main">
        <app-menu *ngIf="!mobileAgent || !mobileDevice"></app-menu>
        <div class="flex flex-row justify-content-between align-items-center flex-wrap-reverse">
          <app-breadcrumb></app-breadcrumb>
          <app-header-credits (messageEvent)="isClosedReceived($event)"></app-header-credits>
        </div>
        <div class="layout-main-content">
            <router-outlet></router-outlet>
        </div>
      </div>
</div>
